import React from "react";
import styled from "styled-components";
import { Table } from "@arco-design/web-react";

import useInfiniteScroll from 'react-infinite-scroll-hook';

import "react-csv-importer/dist/index.css";
import Title from "../../Components/Title";

// MUI -> Arco. The MUI Table/TableHead/TableBody/TableRow/TableCell JSX is
// rewritten into an Arco Table columns config + data source. makeStyles ->
// styled-components. Row selection + the subscriptions Chip column were already
// commented out in the original, so they're dropped here; only Name + Email
// columns remain. Sorting was a no-op (handleRequestSort only logged), so column
// titles are kept without a functional sorter. The infinite-scroll rootRef wraps
// the scroll area and the sentinel row is rendered below the table.

// ------------------------
// Table stuff
// ------------------------

const ScrollContainer = styled.div`
    height: 60vh;
    overflow: auto;
`;

export default function InfiniteScrollContactTable({ contactItems, selected, setSelected, setSelectAllLocal, order, orderBy, contactListFilterId, hasNextPage, loadItemsLoading, totalCount, loadMore, loadContactsError, handleContactRowClick }) {

    const [infiniteRef, { rootRef }] = useInfiniteScroll({
        loadItemsLoading,
        hasNextPage,
        onLoadMore: loadMore,
        disabled: !!loadContactsError,
        rootMargin: '0px 0px 500px 0px',
    });

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Email",
            dataIndex: "email",
        },
    ];

    const rows = contactItems && 'map' in contactItems ? contactItems : [];

    return (
        <>
            <div>
                <Title >{totalCount} Recipients {contactItems.length < totalCount ? "(" + contactItems.length + " displayed)" : ""}</Title>
            </div>
            <ScrollContainer ref={rootRef}>
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    data={rows}
                    pagination={false}
                    style={{ minWidth: 200 }}
                />
                {
                    (hasNextPage && !loadItemsLoading) && (
                        <div ref={infiniteRef}>
                            <i>Loading...</i>
                        </div>
                    )
                }
            </ScrollContainer>
        </>
    )
}
